var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-content __container"},_vm._l((_vm.chats),function(chat){return _c('aha-chat-message',{key:chat.id,attrs:{"message":chat.message,"user":{
      name: chat.name,
      avatar: chat.avatar,
      type: chat.role,
      color: chat.color,
      teamName: chat.teamName,
      isSelf: chat.isSelf,
    },"type":chat.type,"timestamp":chat.timestamp,"received":chat.received,"filteringProfanity":_vm.filteringProfanity},on:{"retrySendingMessage":_vm.retry}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }